import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { GLOSSARY } from "@/lib/learn";

// A small "what's this?" bubble that explains an E.L.M term inline, from the Learning Centre glossary.
export default function HelpTip({ term, className = "" }) {
  const entry = GLOSSARY.find((g) => g.term.toLowerCase() === term.toLowerCase());
  if (!entry) return null;
  const slug = term.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`What is ${term}?`} data-testid={`helptip-${slug}`}
          className={`inline-flex h-5 w-5 items-center justify-center rounded-full text-muted-foreground/70 transition-colors hover:bg-secondary hover:text-foreground ${className}`}>
          <HelpCircle className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72" data-testid={`helptip-content-${slug}`} onClick={(e) => e.stopPropagation()}>
        <p className="text-sm font-semibold">{entry.term}</p>
        <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{entry.def}</p>
        <Link to="/learn?tab=glossary" className="mt-2 inline-block text-xs text-accent underline underline-offset-2" data-testid={`helptip-learn-more-${slug}`}>More in the Learning Centre</Link>
      </PopoverContent>
    </Popover>
  );
}
